import {
  setSessionStorageItemWithExpiration,
  SESSION_STORAGE_CLIENTINFO_KEY,
} from './sessionStorage';
import getDataImportClientInfo from './components/Helpers/DataImportUtility';

const handleSetClientInfoInSession = (queryString) => {
  const dataImportClientInfo = getDataImportClientInfo(queryString);

  if (!dataImportClientInfo) {
    return false;
  }

  setSessionStorageItemWithExpiration(
    SESSION_STORAGE_CLIENTINFO_KEY,
    dataImportClientInfo.clientInfo,
    60,
  );
  window.location.replace(dataImportClientInfo.redirectUrl);

  return true;
};

export default handleSetClientInfoInSession;
 